// generated by genversion
export const version = '1.24.0';
//# sourceMappingURL=version.js.map